module.exports = __webpack_public_path__ + "static/media/37.d59ede01.jpg";